import { forwardRef } from "react";

import { Button } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import CloseIcon from "@/icons/CloseIcon";
import { rootCss, iconCss } from "./PanelHeaderCloseButton.style";

const propTypes = {
  eventProperties: PropTypes.object,
  onClick: PropTypes.func,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const PanelHeaderCloseButton = forwardRef(
  ({ eventProperties = {}, onClick }, ref) => {
    return (
      <ButtonWithTrackEvent
        ariaProps={{ "aria-label": "Close" }}
        dataProps={{ "data-qa-selector": "close-panel" }}
        __cssFor={{ root: rootCss }}
        flavor={Button.flavors.incognito}
        onClick={onClick}
        ref={ref}
        {...eventProperties}
      >
        <CloseIcon css={iconCss} />
      </ButtonWithTrackEvent>
    );
  },
);

PanelHeaderCloseButton.propTypes = propTypes;

export default PanelHeaderCloseButton;
